const langAdminNotificationMonitoring = {
	title: {
		tag: 'admin.notification_monitoring.title',
		fr: 'Suivi des envois',
		en: 'Sending monitoring',
	},
	access_denied: {
		tag: 'admin.notification_monitoring.access_denied',
		fr: 'Écran réservé aux administrateurs.',
		en: 'This screen is reserved to administrators.',
	},
	load_error: {
		tag: 'admin.notification_monitoring.load_error',
		fr: 'Impossible de charger le suivi des notifications.',
		en: 'Unable to load the notification monitoring.',
	},
	unavailable: {
		tag: 'admin.notification_monitoring.unavailable',
		fr: "Suivi indisponible pendant l'impersonation d'un investisseur.",
		en: 'Monitoring is unavailable while impersonating an investor.',
	},
	unknown_reason: {
		tag: 'admin.notification_monitoring.unknown_reason',
		fr: 'raison inconnue',
		en: 'unknown reason',
	},
	refresh: {
		tag: 'admin.notification_monitoring.refresh',
		fr: 'Rafraîchir',
		en: 'Refresh',
	},
	sending_disabled: {
		tag: 'admin.notification_monitoring.sending_disabled',
		fr: "L'envoi des notifications est désactivé sur cet environnement.",
		en: 'Notification sending is disabled on this environment.',
	},
	dry_run: {
		tag: 'admin.notification_monitoring.dry_run',
		fr: 'Mode dry-run : les e-mails ne sont pas réellement envoyés.',
		en: 'Dry-run mode: e-mails are not actually sent.',
	},
	kpi_planned: {
		tag: 'admin.notification_monitoring.kpi_planned',
		fr: 'En attente',
		en: 'Waiting',
	},
	kpi_sendable_today: {
		tag: 'admin.notification_monitoring.kpi_sendable_today',
		fr: "Envoyables aujourd'hui",
		en: 'Sendable today',
	},
	kpi_sent_today: {
		tag: 'admin.notification_monitoring.kpi_sent_today',
		fr: "Envoyées aujourd'hui",
		en: 'Sent today',
	},
	kpi_errors_today: {
		tag: 'admin.notification_monitoring.kpi_errors_today',
		fr: "En erreur aujourd'hui",
		en: 'Errors today',
	},
	kpi_max_per_day: {
		tag: 'admin.notification_monitoring.kpi_max_per_day',
		fr: 'Quota par contact et par jour',
		en: 'Quota per contact per day',
	},
	kpi_last_send: {
		tag: 'admin.notification_monitoring.kpi_last_send',
		fr: 'Dernier envoi',
		en: 'Last send',
	},
	status_counts: {
		tag: 'admin.notification_monitoring.status_counts',
		fr: 'Répartition par statut',
		en: 'Count by status',
	},
	recipients: {
		tag: 'admin.notification_monitoring.recipients',
		fr: "File d'attente par contact",
		en: 'Queue by contact',
	},
	column_email: {
		tag: 'admin.notification_monitoring.column_email',
		fr: 'E-mail',
		en: 'E-mail',
	},
	column_name: {
		tag: 'admin.notification_monitoring.column_name',
		fr: 'Nom',
		en: 'Name',
	},
	column_planned: {
		tag: 'admin.notification_monitoring.column_planned',
		fr: 'En attente',
		en: 'Waiting',
	},
	column_sent_today: {
		tag: 'admin.notification_monitoring.column_sent_today',
		fr: "Envoyées aujourd'hui",
		en: 'Sent today',
	},
	column_remaining_quota_today: {
		tag: 'admin.notification_monitoring.column_remaining_quota_today',
		fr: "Quota restant aujourd'hui",
		en: 'Quota left today',
	},
	column_in_error: {
		tag: 'admin.notification_monitoring.column_in_error',
		fr: 'En erreur',
		en: 'In error',
	},
	column_oldest_planned_release_date: {
		tag: 'admin.notification_monitoring.column_oldest_planned_release_date',
		fr: 'Plus ancien document en attente',
		en: 'Oldest waiting document',
	},
	column_estimated_drain_date: {
		tag: 'admin.notification_monitoring.column_estimated_drain_date',
		fr: 'Fin des envois estimée',
		en: 'Estimated last send',
	},
	estimated_drain_date_help: {
		tag: 'admin.notification_monitoring.estimated_drain_date_help',
		fr: 'Estimation au rythme du quota, jours ouvrés, hors jours fériés et horaires du traitement.',
		en: 'Estimate at the quota pace, business days, ignoring holidays and job hours.',
	},
	column_document: {
		tag: 'admin.notification_monitoring.column_document',
		fr: 'Document',
		en: 'Document',
	},
	column_release_date: {
		tag: 'admin.notification_monitoring.column_release_date',
		fr: 'Date de diffusion',
		en: 'Release date',
	},
	column_subject: {
		tag: 'admin.notification_monitoring.column_subject',
		fr: 'Objet',
		en: 'Subject',
	},
	column_status: {
		tag: 'admin.notification_monitoring.column_status',
		fr: 'Statut',
		en: 'Status',
	},
	column_send_datetime: {
		tag: 'admin.notification_monitoring.column_send_datetime',
		fr: "Date d'envoi",
		en: 'Send date',
	},
	column_tracking: {
		tag: 'admin.notification_monitoring.column_tracking',
		fr: 'Dernier événement Mandrill',
		en: 'Last Mandrill event',
	},
	column_reject_reason: {
		tag: 'admin.notification_monitoring.column_reject_reason',
		fr: 'Motif de rejet',
		en: 'Reject reason',
	},
	column_actions: {
		tag: 'admin.notification_monitoring.column_actions',
		fr: 'Actions',
		en: 'Actions',
	},
	action_send: {
		tag: 'admin.notification_monitoring.action_send',
		fr: 'Envoyer maintenant',
		en: 'Send now',
	},
	action_send_help: {
		tag: 'admin.notification_monitoring.action_send_help',
		fr: 'Envoie cette notification immédiatement, sans tenir compte du quota journalier.',
		en: 'Sends this notification right away, ignoring the daily quota.',
	},
	action_resynchronize: {
		tag: 'admin.notification_monitoring.action_resynchronize',
		fr: 'Resynchroniser',
		en: 'Resynchronize',
	},
	action_resynchronize_help: {
		tag: 'admin.notification_monitoring.action_resynchronize_help',
		fr: 'Relit le statut de livraison auprès de Mandrill.',
		en: 'Reloads the delivery status from Mandrill.',
	},
	action_delete: {
		tag: 'admin.notification_monitoring.action_delete',
		fr: 'Supprimer',
		en: 'Delete',
	},
	confirm_title: {
		tag: 'admin.notification_monitoring.confirm_title',
		fr: 'Confirmation',
		en: 'Confirmation',
	},
	confirm_send: {
		tag: 'admin.notification_monitoring.confirm_send',
		fr: "Envoyer maintenant l'e-mail « {{subject}} » à {{email}} ?",
		en: 'Send the e-mail "{{subject}}" to {{email}} now?',
	},
	confirm_retry: {
		tag: 'admin.notification_monitoring.confirm_retry',
		fr: "Renvoyer l'e-mail « {{subject}} » à {{email}} ? L'envoi précédent a été interrompu sans réponse de Mandrill : ce mail est peut-être déjà parti, le contact pourrait le recevoir deux fois.",
		en: 'Resend the e-mail "{{subject}}" to {{email}}? The previous send was interrupted without an answer from Mandrill: this mail may already have left, the contact could receive it twice.',
	},
	confirm_delete: {
		tag: 'admin.notification_monitoring.confirm_delete',
		fr: 'Supprimer la notification « {{subject}} » ? Elle ne sera jamais envoyée.',
		en: 'Delete the notification "{{subject}}"? It will never be sent.',
	},
	confirm: {
		tag: 'admin.notification_monitoring.confirm',
		fr: 'Confirmer',
		en: 'Confirm',
	},
	cancel: {
		tag: 'admin.notification_monitoring.cancel',
		fr: 'Annuler',
		en: 'Cancel',
	},
	action_done: {
		tag: 'admin.notification_monitoring.action_done',
		fr: 'Action effectuée.',
		en: 'Done.',
	},
	action_failed: {
		tag: 'admin.notification_monitoring.action_failed',
		fr: 'Action refusée : {{reason}}',
		en: 'Action refused: {{reason}}',
	},
};

export default langAdminNotificationMonitoring;
